import { TextField as AriaTextField, type TextFieldProps as AriaTextFieldProps, Input } from 'react-aria-components';

import Field, { type FieldBaseProps } from './Field.tsx';

export interface StringFieldProps extends Omit<AriaTextFieldProps, 'value' | 'onChange' | 'className'>, FieldBaseProps {
    value?: string | null;
    onChange?: (value: string) => void;
    inputClassName?: string;
}

// Single-line text input (react-aria's TextField); multi-line text is TextField.
const StringField = ({
    label,
    helpText,
    errorMessage,
    placeholder,
    labelAccessory,
    className,
    inputClassName,
    isRequired,
    value,
    ...props
}: StringFieldProps) => (
    <Field className={className}>
        <AriaTextField
            {...props}
            value={value === undefined ? undefined : (value ?? '')}
            isRequired={isRequired}
            isInvalid={props.isInvalid || !!errorMessage}
        >
            {/* A read-only field has nothing to fill in, so it isn't optional either. */}
            <Field.Header label={label} labelAccessory={labelAccessory} isRequired={isRequired || props.isReadOnly} />
            <Field.Input
                isInvalid={props.isInvalid || !!errorMessage}
                isReadOnly={props.isReadOnly}
                className={inputClassName}
            >
                <Input placeholder={placeholder} />
            </Field.Input>
            <Field.Footer helpText={helpText} errorMessage={errorMessage} />
        </AriaTextField>
    </Field>
);

export default StringField;
